import * as THREE from 'three'
import CustomShaderMaterial from 'three-custom-shader-material/vanilla'
import wobbleVertexShader from '../shaders/wobble/vertex.glsl'
import wobbleFragmentShader from '../shaders/wobble/fragment.glsl'

// Convert GUI hex (sRGB) -> shader uniform (linear)
const toLinearColor = (hex) =>
{
  const c = new THREE.Color(hex)
  // If your renderer outputs SRGB (default for most setups), uniforms should be linear
  c.convertSRGBToLinear()
  return c
}

export default function createWobbleMaterial({
  colorA = '#0000ff',
  colorB = '#ff0000',
  physical = {}
} = {})
{
  const debugObject = { colorA, colorB }

  const uniforms = {
    uTime: new THREE.Uniform(0),

    uPositionFrequency: new THREE.Uniform(0.5),
    uTimeFrequency: new THREE.Uniform(0.4),
    uStrength: new THREE.Uniform(0.346),

    uWarpPositionFrequency: new THREE.Uniform(0.38),
    uWarpTimeFrequency: new THREE.Uniform(0.12),
    uWarpStrength: new THREE.Uniform(1.7),

    // IMPORTANT: store as LINEAR colors in uniforms
    uColorA: new THREE.Uniform(toLinearColor(debugObject.colorA)),
    uColorB: new THREE.Uniform(toLinearColor(debugObject.colorB)),
  }

  const material = new CustomShaderMaterial({
    baseMaterial: THREE.MeshPhysicalMaterial,
    vertexShader: wobbleVertexShader,
    fragmentShader: wobbleFragmentShader,
    uniforms,

    metalness: 0,
    roughness: 0.5,
    color: '#ffffff',
    transmission: 0,
    ior: 1.5,
    thickness: 0.0,
    transparent: false,
    wireframe: false,

    ...physical
  })

  const depthMaterial = new CustomShaderMaterial({
    baseMaterial: THREE.MeshDepthMaterial,
    vertexShader: wobbleVertexShader,
    uniforms,
    depthPacking: THREE.RGBADepthPacking
  })

  const applyToMesh = (mesh) =>
  {
    mesh.material = material
    mesh.customDepthMaterial = depthMaterial
    mesh.castShadow = true
    mesh.receiveShadow = true
  }

  const setColors = (nextA, nextB) =>
  {
    if (nextA)
    {
      debugObject.colorA = nextA
      uniforms.uColorA.value.copy(toLinearColor(nextA))
    }

    if (nextB)
    {
      debugObject.colorB = nextB
      uniforms.uColorB.value.copy(toLinearColor(nextB))
    }
  }

  return { uniforms, material, depthMaterial, debugObject, applyToMesh, setColors }
}
